import { useBranch } from '../context/BranchContext';
import { TOP_BAR_GRADIENT, ENCON_ORANGE, ENCON_BLACK, MUTED_TEXT } from './limitedStyles';

// The glass bar across the top of every Limited Access page.
//   left / centre / right  - the content a page would normally put in its Global Sub-Header
//                            (AppHeader forwards it here), so page menu items stay in the header.
//   user chip (far right)  - the limited user's name / email and their branch, on every page.
const LimitedTopBar = ({ user, left = null, center = null, right = null }) => {
  const { getEffectiveBranch } = useBranch();
  const branch = getEffectiveBranch();

  const email = user?.email || user?.username || '';
  const rawName = user?.display_name || user?.full_name || '';
  const showName = !!rawName && rawName !== email;
  const branchCode = branch?.code || branch?.id || user?.branch_id || '';
  const branchName = branch?.name || '';
  const branchLabel = branchName && branchName !== branchCode ? `${branchCode} \u00B7 ${branchName}` : branchCode;

  return (
    <header
      data-testid="limited-top-bar"
      className="sticky top-0 z-30 flex flex-wrap items-center gap-2 px-3 md:px-4 py-1.5 min-h-[52px] rounded-b-3xl md:grid"
      style={{
        backgroundImage: TOP_BAR_GRADIENT,
        backgroundColor: 'rgba(255,255,255,0.72)',
        backdropFilter: 'blur(14px) saturate(1.5)',
        WebkitBackdropFilter: 'blur(14px) saturate(1.5)',
        boxShadow: '0 4px 14px rgba(29,29,27,0.10)',
        gridTemplateColumns: 'minmax(0,1fr) auto minmax(0,1fr)',
      }}
    >
      <div className="flex items-center gap-1.5 min-w-0" data-testid="limited-top-bar-left">
        {left}
      </div>

      <div className="flex items-center justify-center gap-2 min-w-0" data-testid="limited-top-bar-center">
        {center}
      </div>

      <div className="flex items-center justify-end gap-2 min-w-0 ml-auto md:ml-0" data-testid="limited-top-bar-right">
        {right}
        <div
          data-testid="limited-user-chip"
          className="flex items-center gap-2 rounded-full pl-3 pr-1.5 py-1 min-w-0"
          style={{
            background: 'rgba(255,255,255,0.92)',
            border: '1px solid rgba(255,255,255,0.9)',
            boxShadow: '0 3px 10px rgba(29,29,27,0.18)',
          }}
        >
          <div className="hidden sm:block min-w-0 text-right leading-tight">
            {showName && (
              <div className="text-[11px] font-bold truncate max-w-[180px]" style={{ color: ENCON_BLACK }}>
                {rawName}
              </div>
            )}
            <div
              className={`truncate max-w-[180px] ${showName ? 'text-[10px]' : 'text-[11px] font-bold'}`}
              style={{ color: showName ? MUTED_TEXT : ENCON_BLACK }}
            >
              {email}
            </div>
          </div>
          <span
            data-testid="limited-branch-pill"
            className="shrink-0 rounded-full px-2.5 py-1 text-[11px] font-bold text-white truncate max-w-[170px]"
            style={{ background: ENCON_ORANGE }}
          >
            {branchLabel}
          </span>
        </div>
      </div>
    </header>
  );
};

export default LimitedTopBar;
